import DottedLoader from './DottedLoader';

export default DottedLoader;
